import { render, staticRenderFns } from "./VolunteerWork.vue?vue&type=template&id=1147e4b0&"
import script from "./VolunteerWork.vue?vue&type=script&lang=ts&"
export * from "./VolunteerWork.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports